/**
 * O fundo que o vidro refrata.
 *
 * A versão anterior era uma malha de gradientes macios — e o protótipo do
 * Vitrine mediu que isso **não mostra refração nenhuma**: entortar um degradê
 * suave produz outro degradê suave. Sem borda dura atrás, todo o custo do
 * `feDisplacementMap` não desenha nada.
 *
 * O desenho mora em `src/styles/fundo.css`, junto do resto do sistema: a
 * malha de cor numa camada, a grade e os anéis noutra.
 */
export function Background() {
  return <div aria-hidden className="fundo" />
}
